"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.StyleUserName = exports.StyleUserInfo = exports.StyleUserDetailsMenu = exports.StyleUserDetailsCollapse = exports.StyleUserDetailsButton = exports.StyleUserDetails = exports.StyleSeeDetails = exports.StyleCloseWrapper = exports.StyleButton = exports.StyleAvatarWrapper = exports.StyleArrow = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _color = _interopRequireDefault(require("webmotors-react-pj/tokens/color"));
var _responsive = _interopRequireDefault(require("webmotors-react-pj/tokens/responsive"));
var _button = _interopRequireDefault(require("webmotors-react-pj/button"));
var _typescript = require("typescript");
var _default = exports.default = _styledComponents.default.div.withConfig({
  componentId: "sc-8vgbho-0"
})(["margin-bottom:8px;"]);
const StyleUserInfo = exports.StyleUserInfo = _styledComponents.default.div.withConfig({
  displayName: "StyleUserInfo",
  componentId: "sc-8vgbho-1"
})(["display:flex;justify-content:space-between;align-items:center;padding:0px 8px 0px 4px;"]);
const StyleAvatarWrapper = exports.StyleAvatarWrapper = _styledComponents.default.div.withConfig({
  displayName: "StyleAvatarWrapper",
  componentId: "sc-8vgbho-2"
})(["display:flex;align-items:center;"]);
const StyleButton = exports.StyleButton = (0, _styledComponents.default)(_button.default).withConfig({
  displayName: "StyleButton",
  componentId: "sc-8vgbho-3"
})([""]);
const StyleUserDetails = exports.StyleUserDetails = _styledComponents.default.div.withConfig({
  displayName: "StyleUserDetails",
  componentId: "sc-8vgbho-4"
})(["margin-left:8px;"]);
const StyleCloseWrapper = exports.StyleCloseWrapper = _styledComponents.default.div.withConfig({
  displayName: "StyleCloseWrapper",
  componentId: "sc-8vgbho-5"
})(["margin:0;img{width:16px;vertical-align:middle;}"]);
const StyleUserName = exports.StyleUserName = _styledComponents.default.div.withConfig({
  displayName: "StyleUserName",
  componentId: "sc-8vgbho-6"
})(["font-family:Figtree;font-size:16px;font-style:normal;font-weight:700;line-height:130%;color:", ";"], (0, _color.default)("white"));
const StyleSeeDetails = exports.StyleSeeDetails = _styledComponents.default.div.withConfig({
  displayName: "StyleSeeDetails",
  componentId: "sc-8vgbho-7"
})(["font-weight:400;font-size:1.2rem;line-height:18px;color:", ";"], (0, _color.default)("gray-3"));
const StyleUserDetailsMenu = exports.StyleUserDetailsMenu = _styledComponents.default.div.withConfig({
  displayName: "StyleUserDetailsMenu",
  componentId: "sc-8vgbho-8"
})(["padding:12px 36px 0px 36px;ul{li{a{opacity:1;font-family:Figtree;font-size:14px;font-style:normal;font-weight:400;line-height:120%;padding:12px 0px;span{display:none;}}}}"]);
const StyleUserDetailsButton = exports.StyleUserDetailsButton = _styledComponents.default.div.withConfig({
  displayName: "StyleUserDetailsButton",
  componentId: "sc-8vgbho-9"
})(["font-size:1.2rem;line-height:18px;padding:8px 0;svg{width:20px;margin-right:8px;vertical-align:middle;}"]);
const StyleUserDetailsCollapse = exports.StyleUserDetailsCollapse = _styledComponents.default.div.withConfig({
  displayName: "StyleUserDetailsCollapse",
  componentId: "sc-8vgbho-10"
})(["max-height:0;transition:all 0.3s;overflow:hidden;", ""], _ref => {
  let {
    opened
  } = _ref;
  return opened && "\n        transition: all 0.3s;\n        max-height: 166px;\n  ";
});
const StyleArrow = exports.StyleArrow = _styledComponents.default.div.withConfig({
  displayName: "StyleArrow",
  componentId: "sc-8vgbho-11"
})(["width:24px;height:24px;background-color:", ";-webkit-mask-image:url('/assets/img/icons/arrow-right.svg');mask-image:url('/assets/img/icons/arrow-right.svg');transform:", ";-webkit-transition:all .3s ease-in-out;-moz-transition:all .3s ease-in-out;transition:all .3s ease-in-out;"], (0, _color.default)('white'), _ref2 => {
  let {
    openned
  } = _ref2;
  return openned && 'rotate(-92deg)';
});